import { connect } from 'react-redux'
import Render from './Render'

const mapStateToProps = state => ({
  user: state.user
})

export default connect(
  mapStateToProps
)(Render)



// WEBPACK FOOTER //
// ./src/components/Layout/Render/index.js